import type {ComponentProps} from 'react';
import {useCallback, useEffect, useRef, useState} from 'react';

import type {TextInput} from '../TextInput';
import type {Props} from './types';

import {payloadActionCreator} from '../../utils/events';

export const useController = ({
  onChange,
  pattern = /\D/g,
  value,
}: Pick<Props, 'onChange' | 'pattern' | 'value'>) => {
  const [code, setCode] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);

  const patternRegexp = useRef<RegExp>(null);

  useEffect(() => {
    if (value !== undefined) {
      setCode(value);
    }
  }, [value]);

  useEffect(() => {
    if (pattern) {
      patternRegexp.current = new RegExp(pattern);
    }
  }, [pattern]);

  const changeHandler: Required<ComponentProps<typeof TextInput>>['onChange'] =
    useCallback(
      action => {
        let newCode = action.payload?.text || '';

        if (patternRegexp.current) {
          newCode = newCode.replace(patternRegexp.current, '');
        }

        onChange?.(payloadActionCreator({code: newCode}));

        if (value === undefined) {
          setCode(newCode);
        }
      },
      [onChange, value],
    );

  const focusHandler = useCallback(() => {
    setIsFocused(true);
  }, []);

  const blurHandler = useCallback(() => {
    setIsFocused(false);
  }, []);

  return {blurHandler, changeHandler, code, focusHandler, isFocused};
};
